type SortResult<T> = (a: T, b: T) => number;

const getPrivateValue = (val: any) =>
    typeof val === 'string' ? val.trim() : val;

export function sortList<T extends Record<string, any>>(
    key: string,
    secondaryKey?: string,
    order = 'asc',
): SortResult<T> {
    const param = order === 'asc' ? 1 : -1;

    return (a: T, b: T) =>
        a[key] === undefined || b[key] === undefined
            ? 0
            : getPrivateValue(a[key]) < getPrivateValue(b[key])
              ? -1 * param
              : getPrivateValue(a[key]) > getPrivateValue(b[key])
                ? 1 * param
                : secondaryKey &&
                    getPrivateValue(a[secondaryKey]) <
                        getPrivateValue(b[secondaryKey])
                  ? -1 * param
                  : secondaryKey &&
                      getPrivateValue(a[secondaryKey]) >
                          getPrivateValue(b[secondaryKey])
                    ? 1 * param
                    : 0;
}

function* values<T extends Record<string, any>>(obj: T) {
    for (const prop of Object.keys(obj)) {
        yield obj[prop];
    }
}

export function distinct<T extends Record<string, any>>(
    list: Array<T>,
    key: string,
): Array<T> {
    const unique: Record<string, T> = {};
    list.map((item) => {
        unique[item[key]] = item;
    });
    return Array.from(values(unique));
}

// Array.from( new Set( list ) ).sort( _sortList( name ) );
